import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../asset/TIE_LOGO.png";
// import SearchIcon from "@mui/icons-material/Search";
import { Icon } from "@iconify/react";
import axios from "axios";
import { WEB_URL } from "src/config";

// Centralized Nav Config

const navConfig = {
  default: [
    {
      title: "Dashboard",
      icon: <Icon icon="tdesign:dashboard-1" />,
      path: "home",
    },
    {
      title: "Support",
      icon: <Icon icon="ic:baseline-contact-phone" />,
      path: "support",
    },
    { title: "Order", icon: <Icon icon="ion:cart-outline" />, path: "order" },
    {
      title: "Community",
      icon: <Icon icon="heroicons-solid:user-group" />,
      path: "community",
    },
  ],
  studyAbroad: [
    {
      title: "Dashboard",
      icon: <Icon icon="tdesign:dashboard-1" />,
      path: "home",
    },
    {
      title: "Study Abroad Home",
      icon: <Icon icon="ion:home" />,
      path: "admission",
    },
    {
      title: "Document Management",
      icon: <Icon icon="mdi:file-document" />,
      path: "documentsverification",
    },
    {
      title: "Resource",
      icon: <Icon icon="grommet-icons:resources" />,
      path: "resources",
    },
    {
      title: "Support",
      icon: <Icon icon="ic:baseline-contact-phone" />,
      path: "support",
    },
    {
      title: "Order",
      icon: <Icon icon="ion:cart-outline" />,
      path: "order",
    },
    {
      title: "Community",
      icon: <Icon icon="heroicons-solid:user-group" />,
      path: "community",
    },
  ],
  testPrep: [
    {
      title: "Dashboard",
      icon: <Icon icon="tdesign:dashboard-1" />,
      path: "home",
    },
    {
      title: "Test Prep Home",
      icon: <Icon icon="ion:home" />,
      path: "test-prep",
    },

    {
      title: "Support",
      icon: <Icon icon="ic:baseline-contact-phone" />,
      path: "support",
    },
    {
      title: "Order",
      icon: <Icon icon="ion:cart-outline" />,
      path: "order",
    },
    {
      title: "Community",
      icon: <Icon icon="heroicons-solid:user-group" />,
      path: "community",
    },
  ],
  userBoard: [
    {
      title: "Dashboard",
      icon: <Icon icon="tdesign:dashboard-1" />,
      path: "home",
    },
    {
      title: "Test Prep Home",
      icon: <Icon icon="ion:home" />,
      path: "test-prep",
    },
    {
      title: "User Board",
      icon: <Icon icon="mingcute:black-board-2-line" />,
      path: "user-board",
    },
    {
      title: "Planner",
      icon: <Icon icon="streamline:class-lesson" />,
      path: "planner",
    },
    {
      title: "Learning Resources",
      icon: <Icon icon="grommet-icons:resources" />,
      path: "learningresources",
    },
    {
      title: "Mock Test",
      icon: <Icon icon="heroicons:light-bulb" />,
      path: "mocktest",
    },
    {
      title: "Performance",
      icon: <Icon icon="game-icons:progression" />,
      path: "performance",
    },
    {
      title: "Support",
      icon: <Icon icon="ic:baseline-contact-phone" />,
      path: "support",
    },
    {
      title: "Order",
      icon: <Icon icon="ion:cart-outline" />,
      path: "order",
    },
    {
      title: "Community",
      icon: <Icon icon="heroicons-solid:user-group" />,
      path: "community",
    },
  ],
};

const TopBar = () => {
  const navigate = useNavigate();
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const [profileImage, setProfileImage] = useState("");

  const token = sessionStorage.getItem("authToken");

  useEffect(() => {
    const readMoreClicked = sessionStorage.getItem("readMoreClicked");
    if (readMoreClicked) {
    }
  }, []);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}student/get-student-web`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        const data = response.data.data;
        setProfileImage(data?.image);
        sessionStorage.setItem("profileImg", data?.image);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [token]);
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleLogout = () => {
    setLogoutDialogOpen(true);
  };

  const handleLogoClick = () => {
    sessionStorage.removeItem("courseId");
    sessionStorage.removeItem("courseName");
    sessionStorage.removeItem("readMoreClicked");

    // navigate("/dashboard/home");
  };

  const confirmLogout = () => {
    sessionStorage.clear();

    setLogoutDialogOpen(false);
    navigate("/login");
  };

  const username = sessionStorage.getItem("username");

  // Determine which nav config to use
  let navItems = navConfig.default;
  if (
    location.pathname.startsWith("/dashboard/admission") ||
    location.pathname.startsWith("/dashboard/studyabroad") ||
    location.pathname.startsWith("/dashboard/documentsverification") ||
    location.pathname.startsWith("/dashboard/resources")
  ) {
    navItems = navConfig.studyAbroad;
  }
  if (
    location.pathname.startsWith("/dashboard/user-board") ||
    location.pathname.startsWith("/dashboard/mocktest") ||
    location.pathname.startsWith("/dashboard/planner") ||
    location.pathname.startsWith("/dashboard/learningresources") ||
    location.pathname.startsWith("/dashboard/performance")
  ) {
    navItems = navConfig.userBoard;
  } else if (location.pathname.startsWith("/dashboard/test-prep")) {
    navItems = navConfig.testPrep;
  }

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#00999E",
        padding: "18px 30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ display: { md: "none", xs: "block" } }}>
            <Box sx={{ display: "flex", flexDirection: "row", color: "white" }}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={handleDrawerOpen}
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <Drawer
              anchor="left"
              open={drawerOpen}
              onClose={handleDrawerClose}
              ModalProps={{ keepMounted: true }}
              sx={{
                "& .MuiDrawer-paper": {
                  width: { sm: "30%", xs: "70%" },
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "1rem",
                }}
              >
                <Link
                  component={RouterLink}
                  to={WEB_URL}
                  onClick={handleLogoClick}
                  className="custom-link"
                >
                  <img width="150px" src={logo} alt="Logo" />
                </Link>
                <IconButton
                  onClick={handleDrawerClose}
                  sx={{ alignSelf: "flex-start" }}
                >
                  <CloseIcon sx={{ color: "#00999E" }} />
                </IconButton>
              </Box>
              <List
                sx={{
                  marginTop: "20px",
                }}
              >
                {navItems.map((item, index) => {
                  const fullPath = `/dashboard/${item.path}`;

                  // Check if this path exactly matches or is a parent of the current location
                  const isExactMatch = location.pathname === fullPath;
                  const isParentMatch =
                    location.pathname.startsWith(fullPath + "/") &&
                    !navItems.some((i) => {
                      const iFull = `/dashboard/${i.path}`;
                      return (
                        iFull !== fullPath &&
                        location.pathname.startsWith(iFull + "/")
                      );
                    });

                  const isSelected = isExactMatch || isParentMatch;

                  return (
                    <ListItem
                      key={index}
                      sx={{
                        margin: "5px 0",
                        padding: "8px 10px",
                        fontWeight: "500",
                        backgroundColor: isSelected ? "#C9EFFB" : "transparent",
                        color: isSelected ? "#000" : "#706C6D",
                        "&:hover": {
                          backgroundColor: "#C9EFFB",
                          color: "#000",
                        },
                        cursor: "pointer",
                        transition: "backgroundColor 0.3s linear",
                        borderRadius: "5px",
                      }}
                      onClick={() => navigate(fullPath)}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: "auto",
                          marginRight: "8px",
                          fontSize: "18px",
                          color: isSelected ? "#000" : "#706C6D",
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <Typography
                        variant="inherit"
                        sx={{
                          fontSize: "14px",
                          color: isSelected ? "#000" : "#706C6D",
                        }}
                      >
                        {item.title}
                      </Typography>
                    </ListItem>
                  );
                })}
              </List>
            </Drawer>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{ display: " flex", flexDirection: "row", alignItems: "center" }}
      >
        <Box
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "40px",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            cursor: "pointer",
            padding: "6px",
            mx: "10px",
          }}
          onClick={() => {
            navigate("/dashboard/profileupdate");
          }}
        >
          <Typography
            sx={{
              color: "#000000",
              fontWeight: "550",
              fontSize: "15px",
              mx: "10px",
            }}
          >
            Hey, {username}
          </Typography>
          {profileImage === null ? (
            <Avatar />
          ) : (
            <Box
              sx={{
                borderRadius: "50%",
                overflow: "hidden",
                border: "1px solid #00999E",
                boxShadow: 10,

                width: "40px",
                height: "40px",
              }}
            >
              <img
                src={profileImage}
                alt="profile_pic"
                width={"100%"}
                height={"100%"}
              />
            </Box>
          )}
        </Box>

        <Box
          sx={{
            height: "45px",
            width: "45px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "50%",
            backgroundColor: "#fff",
            padding: "10px",
          }}
          onClick={handleLogout}
        >
          <Icon
            icon="ep:switch-button"
            style={{ color: "#000000", fontSize: "25px" }}
          />{" "}
        </Box>
      </Box>

      <Dialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: { sm: "450px", xs: "300px" },
          },
        }}
      >
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setLogoutDialogOpen(false)}
          >
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={confirmLogout}>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TopBar;
